import { ActivityBlockTypename, BadgeBlockTypename, CrmObjectBlockTypename, DateBlockTypename, DividerBlockTypename, TextFieldBlockTypename, TimelineBlockTypename } from 'chatspot-core/__generated__/chirp/com/hubspot/copilot/rpc/v2/CopilotMessageService';
import ActivityBlock from './blocks/ActivityBlock';
import BadgeBlock from './blocks/BadgeBlock';
import CrmObjectBlock from './blocks/CrmObjectBlock';
import DateBlock from './blocks/DateBlock';
import DividerBlock from './blocks/DividerBlock';
import TextFieldBlock from './blocks/TextFieldBlock';
import TimelineBlock from './blocks/TimelineBlock';
import { jsx as _jsx } from "react/jsx-runtime";
const ComposableBlocks = ({
  blocks,
  message,
  callbacks,
  sectionId
}) => {
  return blocks.map((block, index) => {
    switch (block.__typename) {
      case CrmObjectBlockTypename:
        return /*#__PURE__*/_jsx(CrmObjectBlock, {
          block: block,
          callbacks: callbacks
        }, index);
      case BadgeBlockTypename:
        return /*#__PURE__*/_jsx(BadgeBlock, {
          block: block
        }, index);
      case DateBlockTypename:
        return /*#__PURE__*/_jsx(DateBlock, {
          block: block
        }, index);
      case TextFieldBlockTypename:
        return /*#__PURE__*/_jsx(TextFieldBlock, {
          block: block,
          message: message,
          callbacks: callbacks,
          sectionId: sectionId
        }, index);
      case ActivityBlockTypename:
        return /*#__PURE__*/_jsx(ActivityBlock, {
          block: block,
          message: message,
          callbacks: callbacks,
          sectionId: sectionId
        }, index);
      case TimelineBlockTypename:
        return /*#__PURE__*/_jsx(TimelineBlock, {
          block: block,
          message: message,
          callbacks: callbacks,
          sectionId: sectionId
        }, index);
      case DividerBlockTypename:
        return /*#__PURE__*/_jsx(DividerBlock, {}, index);
      default:
        return null;
    }
  });
};
export default ComposableBlocks;